import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("AccountPlanStore");
export const useAccountPlanStoreActions = useActions;
export const useAccountPlanStoreGetters = useGetters;
export const useAccountPlanStoreMutations = useMutations;
export const useAccountPlanStoreState = useState;